<template>
  <div class="code mr-2 xl:mr-0 xl:ml-6 z-0">
    <h3 class="mb-2 uppercase font-medium">
      {{ label }}
    </h3>
    <div class="relative border border-solid border-gray-200 bg-white px-10 py-1 text-xl md:text-4xl font-mono font-bold rounded-lg">
      <div v-if="label == 'IMPA Code'" aria-hidden="true" class="text-left absolute top-0 right-0 bottom-0 left-0 overflow-hidden text-xs">
        <div class="block w-64 opacity-25 bg-gray-200 text-gray-600" style="transform:rotate(-10deg); margin-top:-20px">
          <span v-for="index in 30" :key="index">
            IMPA CODE
          </span>
        </div>
      </div>
      <span class="relative z-10 text-gray-900">
        {{ value }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: 'XXXXXX'
    },
    value: {
      type: String,
      default: 'XXXXXX'
    }
  }
}
</script>

<style>

</style>
